import { Layout } from 'components/missed-deal-feedback/components/layout';
import Skeleton from 'react-loading-skeleton';
export function MissedDealFeedbackLoading() {
  return (
    <Layout.Wrapper>
      <Layout.Body>
        <table className="table table-sm border table-form mt-4 mb-0 ms-xxl-auto w-100">
          <thead>
            <tr>
              <th className="w-50">
                <Skeleton width="10em" />
              </th>
              <th className="w-25">
                <Skeleton width="2.5em" />
              </th>
              <th className="w-25">
                <Skeleton />
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="text-nowrap align-middle border px-1" scope="row">
                <Skeleton width="10em" height="1.4em" />
              </td>
              <td></td>
              <td className="border"></td>
              <td className="align-middle text-center px-1">
                <button className="btn" type="button" disabled>
                  <Skeleton width="1.2em" height="1.4em" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </Layout.Body>
      <div className="text-end mt-3" role="group">
        <button className="btn btn-flat-primary btn-icon-start" disabled>
          <span className="pe-2">
            <Skeleton width="1.2em" />
          </span>
          <Skeleton width="12em" />
        </button>
        <button className="btn btn-flat-secondary btn-icon-start" disabled>
          <Skeleton width="5em" />
          <span className="ps-2">
            <Skeleton width="1.2em" />
          </span>
        </button>
      </div>
      <div className="flex-grow-1 mt-3">
        <Skeleton height="15em" />
      </div>
    </Layout.Wrapper>
  );
}
